import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill={color} d="M181.333 0H74.667c-17.643 0-32 14.357-32 32v448c0 17.643 14.357 32 32 32h106.667c17.643 0 32-14.357 32-32V32c-.001-17.643-14.358-32-32.001-32zM437.333 0H330.667c-17.643 0-32 14.357-32 32v448c0 17.643 14.357 32 32 32h106.667c17.643 0 32-14.357 32-32V32c-.001-17.643-14.358-32-32.001-32z"/>
    </svg>
)

export default class IconPause extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
